import { Header } from './sections/Header';
import { Hero } from './sections/Hero';
import { Features } from './sections/Features';
import { Coverage } from './sections/Coverage';
import { Trust } from './sections/Trust';
import { Stat } from './sections/Stat';
import { Faq } from './sections/Faq';
import { Cta } from './sections/Cta';
import { Footer } from './sections/Footer';

/** The landing page. Figma TISAz0279hyWnsjVMJfcvB, frame "Landing" (59:8519) —
 *  a 1400px canvas; the root font size in index.css scales it as one. The gaps
 *  between sections are the distances measured between their frames. */
export function App() {
  return (
    <div className="mx-auto w-full bg-surface font-sans lg:w-[1400px]">
      <Header />
      <Hero />
      <div className="mt-[64px] lg:mt-[132px]">
        <Features />
      </div>
      <div className="mt-[80px] lg:mt-[197px]">
        <Coverage />
      </div>
      <div className="mt-[80px] lg:mt-[200px]">
        <Trust />
      </div>
      <div className="mt-[80px] lg:mt-[200px]">
        <Stat />
      </div>
      <div className="mt-[80px] lg:mt-[200px]">
        <Faq />
      </div>
      <div className="mt-[80px] lg:mt-[196px]">
        <Cta />
      </div>
      <div className="mt-[80px] lg:mt-[200px]">
        <Footer />
      </div>
    </div>
  );
}
